// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__wvWE-","description":"MealItem_description__038gq","price":"MealItem_price__cPeui","form":"MealItem_form__Zs1vD","image":"MealItem_image__v+PZF"};